export interface IAuth {
  id: string;
  token: string;
}

export class AuthModel implements IAuth {
  id: string;
  token: string;
}
